/**
 * Normalizes video data to ensure consistent property names
 * across the application
 */
export const normalizeVideoData = (videoData) => {
  if (!videoData) return {};
  
  return {
    videoId: videoData.videoId || videoData.id || '',
    title: videoData.title || '',
    description: videoData.description || videoData.shortDescription || '',
    thumbnailUrl: videoData.thumbnailUrl || videoData.thumbnail || '',
    duration: videoData.duration || 0,
    position: videoData.position || 0,
    dateAdded: videoData.dateAdded || new Date(),
    // Include other properties
    shortDescription: videoData.shortDescription || videoData.description || '',
    longDescription: videoData.longDescription || videoData.description || '',
    content: videoData.content || {},
    tags: videoData.tags || [],
    thumbnail: videoData.thumbnail || videoData.thumbnailUrl || '',
    id: videoData.id || videoData.videoId || '',
    // Ensure timestamp is carried over or set to 0 (not undefined)
    timestamp: videoData.timestamp !== undefined ? videoData.timestamp : 0,
    ...videoData // Keep any additional properties
  };
};
